export const FIRMWARE_RELEASE_NOTE_PRODUCT_LINES = ["sgs", "dm1", "wireless_test_app"] as const;

export type FirmwareReleaseNoteProductLine = (typeof FIRMWARE_RELEASE_NOTE_PRODUCT_LINES)[number];

export function firmwareReleaseNoteProductLineLabel(line: FirmwareReleaseNoteProductLine): string {
  switch (line) {
    case "dm1":
      return "DM-1 padmount";
    case "wireless_test_app":
      return "Wireless test app";
    case "sgs":
    default:
      return "Main line";
  }
}

export type FirmwareReleaseNoteSelectOption = {
  value: string;
  label: string;
  description: string;
};

/** Closed SearchableSelect label: version and product line, never the notes row id. */
export function firmwareReleaseNoteSelectLabel(input: {
  versionKey: string | null | undefined;
  productLine?: FirmwareReleaseNoteProductLine | null;
}): string {
  const version = (input.versionKey ?? "").trim();
  if (version === "") return "";
  if (input.productLine == null) return version;
  return `${version} · ${firmwareReleaseNoteProductLineLabel(input.productLine)}`;
}

export function firmwareReleaseNoteToSelectOption(note: {
  id: number;
  versionKey: string;
  productLine: FirmwareReleaseNoteProductLine;
}): FirmwareReleaseNoteSelectOption {
  return {
    value: String(note.id),
    label: firmwareReleaseNoteSelectLabel(note),
    description: firmwareReleaseNoteProductLineLabel(note.productLine),
  };
}

export function withFirmwareReleaseNoteSelectOption(
  options: FirmwareReleaseNoteSelectOption[],
  extra: FirmwareReleaseNoteSelectOption | null,
): FirmwareReleaseNoteSelectOption[] {
  if (extra == null || extra.value.trim() === "") return options;
  if (options.some((option) => option.value === extra.value)) return options;
  return [extra, ...options];
}
